import { useState } from 'react';
import { adminLogin as apiLogin, getMe } from '../api/client';

export function useAdminAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => !!localStorage.getItem('admin_token')
  );

  const login = async (email, password) => {
    const data = await apiLogin(email, password);
    localStorage.setItem('admin_token', data.token);
    if (data.landlord) {
      localStorage.setItem('landlord_info', JSON.stringify(data.landlord));
    }
    setIsAuthenticated(true);
    return data;
  };

  const logout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('landlord_info');
    setIsAuthenticated(false);
  };

  const getLandlord = () => {
    try {
      return JSON.parse(localStorage.getItem('landlord_info'));
    } catch {
      return null;
    }
  };

  return { isAuthenticated, login, logout, getLandlord };
}
